import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ClasseProfit } from '../models/ClasseProfit';
import { Step9 } from '../../../../shared/models/component-messages/blocCommun/simp/step9';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';

@Component({
  selector: 'app-classe-profit',
  templateUrl: './classe-profit.component.html'
})
export class ClasseProfitComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'ClasseProfit'
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  
  	@Input() classeProfit : ClasseProfit;

    public step9 = new Step9();

    public radioButtonValue: string;
	  public radioButtonCtrlName: string;
    public readonly region = RadioCheckBoxEnum.region;
    public readonly departement = RadioCheckBoxEnum.departement;
    public readonly etat = RadioCheckBoxEnum.etat;
    public readonly debiteurEtranger = RadioCheckBoxEnum.debiteurEtranger;
    public readonly autresOrganismesPublics = RadioCheckBoxEnum.autresOrganismesPublics;
    public readonly debiteurPrivePersPhysique = RadioCheckBoxEnum.debiteurPrivePersPhysique;
    public readonly groupementCollectivites = RadioCheckBoxEnum.groupementCollectivites;
    public readonly commune = RadioCheckBoxEnum.commune;
    public readonly debiteurPrivePersMorale = RadioCheckBoxEnum.debiteurPrivePersMorale;
    public readonly etablissementsPublicsSante = RadioCheckBoxEnum.etablissementsPublicsSante;
  

  constructor() {}

  public ngOnInit() {
    if (this.classeProfit?.region === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.region;
    } else if (this.classeProfit?.departement === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.departement;
    } else if (this.classeProfit?.etat === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.etat;
    } else if (this.classeProfit?.debiteurEtranger === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.debiteurEtranger;
    } else if (this.classeProfit?.autresOrganismesPublics === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.autresOrganismesPublics;
    } else if (this.classeProfit?.debiteurPrivePersPhysique === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.debiteurPrivePersPhysique;
    } else if (this.classeProfit?.groupementCollectivites === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.groupementCollectivites;
    } else if (this.classeProfit?.commune === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.commune;
    } else if (this.classeProfit?.debiteurPrivePersMorale === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.debiteurPrivePersMorale;
    } else if (this.classeProfit?.etablissementsPublicsSante === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.etablissementsPublicsSante;
    } else {
      this.radioButtonValue = this.region;
    }

    this.radioButtonCtrlName = this.getUid() + '_SepAtt_region';
  }

    getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }  
  
  
}

